import { VideoDescriptionItem, VideoFunctionItem } from 'types/videos'

export const VIDEO_DESCRIPTIONS_TYPES = {
  DEFAULT: 'DEFAULT',
  euro: 'Euro',
  mediaExpert: 'MediaExpert'
}

export const VIDEO_DESCRIPTION_LABELS = {
  DEFAULT: 'Video Description for other partners',
  Euro: 'Video Description for Euro',
  MediaExpert: 'Video Description for Media Expert'
}

export const videoDescriptions: VideoDescriptionItem[] = [
  { partnerName: VIDEO_DESCRIPTIONS_TYPES.DEFAULT, description: '' },
  { partnerName: VIDEO_DESCRIPTIONS_TYPES.euro, description: '' },
  { partnerName: VIDEO_DESCRIPTIONS_TYPES.mediaExpert, description: '' }
]

export const initialVideoFunction: VideoFunctionItem = {
  youtubeId: '',
  descriptions: [
    {
      partnerName: VIDEO_DESCRIPTIONS_TYPES.DEFAULT,
      description: ''
    },
    {
      partnerName: VIDEO_DESCRIPTIONS_TYPES.euro,
      description: ''
    },
    {
      partnerName: VIDEO_DESCRIPTIONS_TYPES.mediaExpert,
      description: ''
    }
  ]
}

export const MAX_VIDEO_FUNCTIONS_COUNT = 5
